
    var riot = require('riot')
    //src: starling/src/tags/autocomplete.html
riot.tag2('autocomplete',
  '<ul ref="list" class="handle-input-click-propagation"> <li each="{result, index in results}" class="handle-input-click-propagation {this.selectedItem == index ? \'selected\' : \'\'}"> <div class="info" oncontextmenu="{stopRightClick}" onmousedown="{makeSelection.bind(null, result)}"> <div class="library-name">{result.attribution}</div> <h4>{result.title}</h4> <span class="summary">{result.summary || result.title}</span> </div> </li> </ul>',
  'autocomplete { z-index: 10000; position: absolute; top: 100px; left: 100px; background: white; visibility: hidden; pointer-events: all; } autocomplete.active { visibility: visible; } autocomplete h4,[data-is="autocomplete"] h4{ margin: 0; color: #555; line-height: 1.2; font-size: 14px; font-weight: 500; } autocomplete .summary,[data-is="autocomplete"] .summary{ font-size: 11px; line-height: 1.2; color: rgba(0,0,0,0.5); display: block; } autocomplete ul,[data-is="autocomplete"] ul{ list-style: none; margin: 0; padding: 0; width: 300px; box-shadow: 0 0 10px rgba(0,0,0,0.2); } autocomplete li,[data-is="autocomplete"] li{ display: flex; margin: 0; padding: 12px; border-bottom: 1px solid #eee; } autocomplete li:hover,[data-is="autocomplete"] li:hover,autocomplete li.selected,[data-is="autocomplete"] li.selected{ background: #f2f2f2; cursor: pointer; } autocomplete .library-name,[data-is="autocomplete"] .library-name{ background: rgba(0,0,0,0.05); color: #999; padding: 0.2em 0.3em; display: inline-block; font-size: 11px; margin-left: -1px; float: right; margin: 0 10px 10px 0; } autocomplete .info,[data-is="autocomplete"] .info{ flex-grow: 1; word-break: break-word; overflow: hidden; }',
  'ref="main" riot-style="top: {this.y}px; left: {this.x}px"', function(opts) {
'use strict';

var _this = this;

this.sequence = 0;
this.renderedSequence = 0;
this.canvas = this.opts.canvas;
this.selectedItem = -1;
this.canvas.autocompleteTag = this;
this.hidden = true;

this.summon = function (x, y, cb) {
  _this.x = x;
  _this.y = y;
  _this.cb = cb;
  _this.refs.main.classList.add('active');
  _this.results = [];
  _this.selectedItem = -1;
  _this.update();
  _this.hidden = false;
};

this.hide = function () {
  _this.cb = null;
  _this.refs.main.classList.remove('active');
  _this.hidden = true;
};

this.makeSelection = function (selection, e) {
  if (e && e.button !== 0) {
    return;
  }
  _this.cb(selection);
  _this.hide();
};

this.isShowing = function () {
  if (_this.cb && _this.results.length) {
    return true;
  }
  return false;
};

this.incrementSelected = function (diff) {
  if (_this.selectedItem + diff < -1) {
    _this.selectedItem = -1;
  } else if (_this.selectedItem + diff >= _this.results.length) {
    _this.selectedItem = _this.results.length - 1;
  } else {
    _this.selectedItem += diff;
  }
  _this.update();
};

this.getSelectedResult = function () {
  if (_this.selectedItem < 0) {
    return;
  }
  if (_this.results) {
    return _this.results[_this.selectedItem];
  }
};

this.updatePosition = function (position) {
  _this.x = position.x;
  _this.y = position.y;
  _this.update();
};

this.getResults = function (q) {
  if (window.config.embedded) {
    return;
  }
  if (window.user.settings && window.user.settings.allowedLibraries.length == 0) {
    return;
  }
  if (q.trim().length == 0) {
    return _this.hide();
  }
  var sequence = _this.sequence++;
  $.ajax({
    url: '/api/nodes/autocomplete',
    data: { query: q, mapId: _this.canvas.store.access.id, allowedLibraries: window.user.settings.allowedLibraries },
    success: function success(data) {
      if (!_this.cb) {
        // title was saved already, ignore any remaining autocomplete results
        return;
      }
      // only show results if they're newer
      if (sequence <= _this.renderedSequence) return;

      _this.renderedSequence = sequence;
      var uniq = {};
      var groomedResults = [];

      for (var _iterator = data, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var d = _ref;

        // brutally strip out duplicates
        var key = d.title.trim() + '@@' + d.library_id;
        if (uniq[key]) continue;
        uniq[key] = true;

        // TODO: make this better
        var attribution = d.library_id == 1 ? 'Wikipedia' : d.author;
        groomedResults.push({
          title: d.title,
          summary: d.summary,
          attribution: attribution,
          librarySlug: d.library_slug,
          externalIdentifier: d.external_identifier,
          canonicalNodeUUID: d.uuid,
          tags: d.tags
        });

        if (groomedResults.length >= 5) break;
      }

      _this.results = groomedResults;
      _this.refs.main.classList.add('active');
      _this.update();
    }
  });
};

this.stopRightClick = function (e) {
  e.stopPropagation();
  _this.canvas.hidePopups();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('autocomplete')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/autocomplete.html
// module id = 597
// module chunks = 0